import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router';
import { Navbar } from '@/components/Navbar';
import { AppServicesProvider } from '@/contexts/app-services';
import { AuthProvider } from '@/contexts/auth';
import { AppRoutes } from '@/routes';
import { appServices } from '@/services/app';

const queryClient = new QueryClient();

export function App() {
  return (
    <AppServicesProvider services={appServices}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <div className="flex h-screen flex-col">
              <div className="min-h-0 flex-shrink-0">
                <Navbar />
              </div>
              <main className="min-h-0 flex-1">
                <AppRoutes />
              </main>
            </div>
          </BrowserRouter>
        </AuthProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </AppServicesProvider>
  );
}
